import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-time",
  templateUrl: "./field-set-time.component.html",
  styles: [],
})
export class FieldSetTimeComponent {
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
